import { useNavigate } from "react-router";
import { useEffect } from "react";
import { LoadingPage } from "@inductiveautomation/ws-components";

const Subscription = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void navigate(`/email-preferences${window.location.search}`);
  }, [navigate]);

  return (
    <LoadingPage baseAssetUrl={window._acctConfig?.BASE_ASSET_URL ?? ""} />
  );
};

export default Subscription;
